/* eslint-disable react/prop-types */
import React from 'react';
import { RangePicker } from 'components/Antd/DatePicker';
import FilterDropdownChoosing from './Choosing';
import classes from './FilterDropdown.module.scss';
import moment from 'moment';
import T from 'i18n-react';

const FilterDropdownDate = ({ items, checks, setChecks, dateVal, setDateVal, hideDateRange }) => {
  const tItems = items || {};
  const itemKeys = Object.keys(items);
  const hasMethodKey = itemKeys.filter((v) => v === 'method').length > 0;
  return (
    <div className={classes.filterDropdownChoosing}>
      {itemKeys.map((tKey, i) => {
        const tCheckValue = checks[tKey] || [];
        return (
          <FilterDropdownChoosing
            key={i}
            items={tItems[tKey] || []}
            checks={tCheckValue}
            setChecks={(val) => {
              if (val?.length > 0) {
                const newChecks = {
                  ...checks,
                  [tKey]: val,
                };
                if (hasMethodKey && tKey === 'field' && !checks[tKey] && !checks?.method) {
                  newChecks['method'] = ['za'];
                }
                setChecks(newChecks);
                setDateVal([]);
              }
            }}
          />
        );
      })}
      {!hideDateRange && (
        <RangePicker
          placeholder={[T.translate('general.from'), T.translate('general.to')]}
          size="large"
          value={
            Array.isArray(dateVal) && dateVal.length ? [moment(dateVal[0]), moment(dateVal[1])] : []
          }
          onChange={(val) => {
            setDateVal(val);
            setChecks([]);
          }}
        />
      )}
    </div>
  );
};

export default FilterDropdownDate;
